import Box from '@mui/material/Box'
import { KestrixTypography } from '@shared'

export const LoginFooter = () => {
  return (
    <Box sx={{ mt: 6, textAlign: 'center' }}>
      <KestrixTypography variant="body2" color="caption">
        &copy; 2025 Kestrix. All rights reserved.
      </KestrixTypography>
    </Box>
  )
}
